import PublishedStories from "../components/published-stories/PublishedStories";

export default function PublishedStoriesPage() {
  return (
  <>
    <h3>Stories List</h3>
    <PublishedStories  content="stories" page="yes"/>

  </>

);
}